<template lang="pug">
div.report-second
  div
    Breadcrumb(style="font-size:12px;")
        BreadcrumbItem(to="/Teacher/reportManage",@click.native="bread") 报告管理
        BreadcrumbItem(style="font-size:12px;color:#3A76D2;font-weight: initial;") {{casename}}
    div.secondtitle
      div(style="display:inline-block",v-if="isreport&&isdelete&&isTeacher&& scoreType===2 || isreport&&isdelete&&isTeacher&& scoreType===0")
        Button.secondbtn1(type= "primary" @click= "insertcheckbox") 一键评分
      div(style="display:inline-block",v-if="isreport&&isdelete&&isTeacher && scoreType===1|| isreport&&isdelete&&isTeacher&& scoreType===0")
        Button.secondbtn1(type= "primary" @click= "insertcheckbox_fix") 智能评分
      div(style="display:inline-block")
        div(style="display:inline-block",v-if="isreport&&isdelete")
          Button.secondbtn(type= "primary",@click="report1") 下载报告
        div(style="display:inline-block",v-if="!isreport")
          span(style="margin-right:16px") 下载报告
          Button.secondbtn(type= "primary",@click="pdfsexport") 确定
          Button(@click= "canclereport") 取消
      //- div(style="display:inline-block")
      //-   div(style="display:inline-block",v-if="isreport&&isdelete")
      //-     Button.secondbtn(type= "primary",@click="delete1") 删除
      //-   div(style="display:inline-block",v-if="!isdelete")
      //-     span(style="margin-right:16px") 删除
      //-     Button.secondbtn(type= "primary",@click="delete2") 确定
      //-     Button(@click= "cancledelete") 取消
      div(style="width:648px; height:auto; float:right")
        Select.info(placeholder="请选择班级",v-model= "form.classId",clearable,@on-change="classChange")
          Option(:key='v.id',:label='v.classname',:value='v.classid',v-for='v in classinfoend')
        Select.info(placeholder="请选择用户",v-model= "form.userName",clearable)
          Option(:key='v.code',:label='v.name',:value='v.name',v-for='v in studentList')
        Select.info(placeholder="请选择审核状态",v-model= "form.experimentMemberAuditStatus",clearable)
          Option(label="已审核",value="已审批")
          Option(label="待审核(进行中)",value="未提交")
          Option(label="待审核(已结束)",value="待审批")
        Button(type="primary",@click="searchmethod") 搜索
    Table(:columns="columnsList" :data="seconddata",@on-selection-change="handleSelectionChange")
    Page.page(v-if="infoorseache",@on-change="handleCurrentChange1" :total="pageData1.totalRecords"
         :page-size="10" :current="pageData1.pageNo" show-elevator show-total)
      span 当前有{{seconddata.length}}条数据,共{{pageData1.totalRecords}}条数据
</template>
<script>
export default {
  data() {
    return {
      experimentId: this.$route.query.experimentId,
      isalldelete: false,
      multipleSelection: [], // 多选
      isreport: true,
      isdelete: true,
      studentList: [],
      isTeacher: true,
      scoredata: [], // 智能评分初始数据
      form: {
        classId: "",
        userName: "",
        experimentMemberAuditStatus: ""
      },
      infoorseache: true,
      classinfoend: [], // 查询班级名称最终数据
      classinfo: [], // 查询班级名称未处理数据
      showCheckbox: false,
      casename: this.$route.query.name,
      secondshow: false,
      page: 1,
      pageData: {}, // 分页总数
      pageData1: {}, // 二级页面分页总数
      reportdata: [], // 一级页面数据
      seconddata: [], // 二级页面数据
      onOff: false,
      onOff1: false,
      columns2: [
        // 二级页面参数
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        // {
        //   title: "序号",
        //   type: "index"
        // },
        {
          title: "实验班级",
          width: "95",
          key: "className",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    cursor: "pointer"
                  },
                  domProps: {
                    title: params.row.className
                  }
                },
                params.row.className
              )
            ]);
          }
        },
        {
          title: "学生姓名",
          width: "90",
          key: "userName"
        },
        {
          title: "账号",
          width: "95",
          key: "userCode"
        },
        {
          title: "系统评分",
          width: "80",
          key: "systemScore"
        },
        {
          title: "教师评分",
          width: "80",
          key: "teacherScore"
        },
        {
          title: "实验状态",
          width: "90",
          key: "toState"
        },
        {
          title: "审核状态",
          width: "140",
          key: "experimentMemberAuditStatus",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    marginRight: "10px",
                    color:
                      // eslint-disable-next-line no-nested-ternary
                      params.row.experimentMemberAuditStatus === "已审批"
                        ? "#00A854"
                        : params.row.experimentMemberAuditStatus === "待审批"
                        ? "#F04B60"
                        : "#cccccc"
                  }
                },
                "●"
              ),
              h(
                "span",
                {
                  style: {
                    color:
                      // eslint-disable-next-line no-nested-ternary
                      params.row.experimentMemberAuditStatus === "已审批"
                        ? "#000000"
                        : params.row.experimentMemberAuditStatus === "待审批"
                        ? "#000000"
                        : "#cccccc"
                  }
                },
                params.row.experimentMemberAuditStatus
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "",
          width: 200,
          render: (h, params) => {
            console.log(this.$role.role);
            if (this.$role.role === "teacher") {
              return h("div", [
                h(
                  "i",
                  {
                    class: "iconfont icon-renwu1",
                    style: "font-size:14px;padding-bottom: 2px;color:#3A76D2;",
                    props: {
                      type: "text",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        console.log(params.row);
                        // if (params.row.distribution !== "政策终结") {
                        //   this.$Message.warning(
                        //     "未到政策终结阶段，不能进行评分!"
                        //   );
                        //   return;
                        // }
                        if (params.row.experimentMemberAuditStatus === "未提交") {
                          this.$Message.warning("学生未提交，不能进行评分!");
                          return;
                        }
                        if (
                          params.row.experimentMemberAuditStatus === "未提交" &&
                          params.row.toState === "已结束"
                        ) {
                          this.$Message.warning("此状态下，不能进行评分!");
                          return;
                        }
                        sessionStorage.setItem("lastUrl", this.$route.fullPath);
                        this.$router.push({
                          path: "/stuReport",
                          query: {
                            id: params.row.id,
                            state: params.row.experimentMemberAuditStatus,
                            usercode: params.row.userCode,
                            experimentid: params.row.experimentId,
                            viewAnswer: params.row.viewAnswer,
                            viewReport: params.row.viewReport
                          }
                        });
                      }
                    }
                  },
                  "评分"
                ),
                h(
                  "i",
                  {
                    style: "padding: 0 12px;color:#D8D8D8;"
                  },
                  "|"
                ),
                h(
                  "i",
                  {
                    class: "ivu-icon icon-xiazai iconfont",
                    style: "font-size:14px;padding-bottom: 2px;color:#3A76D2;cursor:pointer;",
                    props: {
                      type: "text",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        console.sun(this.$route.query);
                        if (params.row.toState === "已结束") {
                          if (params.row.experimentMemberAuditStatus === "已审批") {
                            this.pdfexport(params.row);
                          } else {
                            this.$Message.warning("请先为报告评分!");
                          }
                        } else if (params.row.toState === "进行中") {
                          this.$Message.warning("请先完成实验!");
                        }
                      }
                    }
                  },
                  "下载报告"
                ),
                h(
                  "i",
                  {
                    style: "padding: 0 12px;color:#D8D8D8;"
                  },
                  "|"
                ),
                h(
                  "i",
                  {
                    class: "iconfont icon-shanchu",
                    style: "font-size:14px;padding-bottom: 2px;color:#3A76D2;",
                    props: {
                      type: "text",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        console.log("283", params.row);
                        if (params.row.distribution !== "政策终结") {
                          this.$Message.warning("该数据不可删除");
                          return;
                        }
                        if (params.row.experimentMemberAuditStatus !== "已审批") {
                          this.$Message.warning("该数据不可删除");
                          return;
                        }
                        this.$Modal.confirm({
                          title: "系统提示",
                          content: "<p>你确定要删除此数据吗?</p>",
                          onOk: () => {
                            // this.handlesocredata();
                            this.deleteExperimentMeber(params.row);
                          }
                        });
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
            if (this.$role.role === "admin") {
              return h("div", [
                h(
                  "i",
                  {
                    class: "ivu-icon icon-xiazai iconfont",
                    style: "font-size:14px;padding-bottom: 2px;color:#3A76D2;",
                    props: {
                      type: "text",
                      size: "small"
                    },
                    on: {
                      click: () => {
                       if (params.row.toState === "已结束") {
                          if (params.row.experimentMemberAuditStatus === "已审批") {
                            this.pdfexport(params.row);
                          } else {
                            this.$Message.warning("请先为报告评分!");
                          }
                        } else if (params.row.toState === "进行中") {
                          this.$Message.warning("请先完成实验!");
                        }
                        // console.log(params.row)
                      }
                    }
                  },
                  "下载报告"
                )
              ]);
            }
          }
        }
      ],
      scoreType: +this.$route.query.scoreType
    };
  },
  computed: {
    columnsList() {
      if (!this.isreport) {
        return this.columns2;
      }
      return [
        {
          title: "序号",
          align: "left",
          width: 90,
          render: (h, params) => {
            return h(
              "p",
              {
                props: {
                  content: params.row.userName,
                  placement: "top"
                }
              },
              params.index + 1
            );
          }
        },
        {
          title: "实验班级",
          width: "95",
          key: "className",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    cursor: "pointer"
                  },
                  domProps: {
                    title: params.row.className
                  }
                },
                params.row.className
              )
            ]);
          }
        },
        {
          title: "学生姓名",
          width: "90",
          key: "userName"
        },
        {
          title: "账号",
          width: "95",
          key: "userCode"
        },
        {
          title: "系统评分",
          width: "80",
          key: "systemScore"
        },
        {
          title: "教师评分",
          width: "80",
          key: "teacherScore"
        },
        {
          title: "实验状态",
          width: "90",
          key: "toState"
        },
        {
          title: "审核状态",
          width: "140",
          key: "experimentMemberAuditStatus",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    marginRight: "10px",
                    color:
                      // eslint-disable-next-line no-nested-ternary
                      params.row.experimentMemberAuditStatus === "已审批"
                        ? "#00A854"
                        : params.row.experimentMemberAuditStatus === "待审批"
                        ? "#F04B60"
                        : "#cccccc"
                  }
                },
                "●"
              ),
              h(
                "span",
                {
                  style: {
                    color:
                      // eslint-disable-next-line no-nested-ternary
                      params.row.experimentMemberAuditStatus === "已审批"
                        ? "#000000"
                        : params.row.experimentMemberAuditStatus === "待审批"
                        ? "#000000"
                        : "#cccccc"
                  }
                },
                params.row.experimentMemberAuditStatus
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "",
          width: 200,
          render: (h, params) => {
            console.log(this.$role.role);
            if (this.$role.role === "teacher") {
              return h("div", [
                h(
                  "i",
                  {
                    class: "iconfont icon-renwu1",
                    style: "font-size:14px;padding-bottom: 2px;color:#3A76D2;",
                    props: {
                      type: "text",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        console.log(params.row);
                        // if (params.row.distribution !== "政策终结") {
                        //   this.$Message.warning(
                        //     "未到政策终结阶段，不能进行评分!"
                        //   );
                        //   return;
                        // }
                        if (params.row.experimentMemberAuditStatus === "未提交") {
                          this.$Message.warning("学生未提交，不能进行评分!");
                          return;
                        }
                        if (
                          params.row.experimentMemberAuditStatus === "未提交" &&
                          params.row.toState === "已结束"
                        ) {
                          this.$Message.warning("此状态下，不能进行评分!");
                          return;
                        }
                        sessionStorage.setItem("lastUrl", this.$route.fullPath);
                        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                        this.$router.push({
                          path: "/stuReport",
                          query: {
                            id: params.row.id,
                            state: params.row.experimentMemberAuditStatus,
                            usercode: params.row.userCode,
                            experimentid: params.row.experimentId,
                            viewAnswer: params.row.viewAnswer,
                            viewReport: params.row.viewReport
                          }
                        });
                      }
                    }
                  },
                  "评分"
                ),
                h(
                  "i",
                  {
                    style: "padding: 0 12px;color:#D8D8D8;"
                  },
                  "|"
                ),
                h(
                  "i",
                  {
                    class: "ivu-icon icon-xiazai iconfont",
                    style: "font-size:14px;padding-bottom: 2px;color:#3A76D2;cursor:pointer;",
                    props: {
                      type: "text",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        console.sun(this.$route.query);
                        if (params.row.toState === "已结束") {
                          if (params.row.experimentMemberAuditStatus === "已审批") {
                            this.pdfexport(params.row);
                          } else {
                            this.$Message.warning("请先为报告评分!");
                          }
                        } else if (params.row.toState === "进行中") {
                          this.$Message.warning("请先完成实验!");
                        }
                      }
                    }
                  },
                  "下载报告"
                ),
                h(
                  "i",
                  {
                    style: "padding: 0 12px;color:#D8D8D8;"
                  },
                  "|"
                ),
                h(
                  "i",
                  {
                    class: "iconfont icon-shanchu",
                    style: "font-size:14px;padding-bottom: 2px;color:#3A76D2;",
                    props: {
                      type: "text",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        console.log("283", params.row);
                        if (params.row.distribution !== "政策终结") {
                          this.$Message.warning("该数据不可删除");
                          return;
                        }
                        if (params.row.experimentMemberAuditStatus !== "已审批") {
                          this.$Message.warning("该数据不可删除");
                          return;
                        }
                        this.$Modal.confirm({
                          title: "系统提示",
                          content: "<p>你确定要删除此数据吗?</p>",
                          onOk: () => {
                            // this.handlesocredata();
                            this.deleteExperimentMeber(params.row);
                          }
                        });
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
            if (this.$role.role === "admin") {
              return h("div", [
                h(
                  "i",
                  {
                    class: "ivu-icon icon-xiazai iconfont",
                    style: "font-size:14px;padding-bottom: 2px;color:#3A76D2;",
                    props: {
                      type: "text",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        // if (
                        //   params.row.distribution !== this.$route.query.caseExperimentDistribution
                        // ) {
                        //   this.$Message.warning("未到案例结束阶段，不能下载");
                        // } else
                        if (params.row.toState !== "已结束") {
                          this.$Message.warning("请先完成实验!");
                        } else if (params.row.experimentMemberAuditStatus !== "已审批") {
                          this.$Message.warning("请先为报告评分!");
                        } else if (params.row.experimentMemberAuditStatus === "未提交") {
                          this.$Message.warning("请先完成实验!");
                        } else {
                          this.pdfexport(params.row);
                        }
                        // console.log(params.row)
                      }
                    }
                  },
                  "下载报告"
                )
              ]);
            }
          }
        }
      ];
    }
  },
  methods: {
    classChange(c) {
      this.form.userName = "";
      if (c) {
        this.$http
          .listClassMemberRequest({
            classRoom_uuid: c
          })
          .then((res) => {
            this.studentList = res.data.data.list;
          });
      } else {
        this.studentList = [];
      }
    },
    downloadFile(url, fileName) {
      // 一级页面下载单个文件
      const a = document.createElement("a");
      a.href = url;
      if (fileName) {
        a.download = fileName;
      } else {
        a.download = "";
      }
      a.click();
    },
    handleSelectionChange(val) {
      // 多选操作
      this.multipleSelection = val;
      console.log(val);
    },
    pdfexport(row) {
      console.log("🚀 ~ pdfexport ~ row:", row);

      // 二级页面下载单个文件
      const data = {
        experimentId: row.experimentId,
        userId: row.userCode
      };
      this.$http.exportExperimentReport(data).then((res) => {
        this.downloadFile(res.data.data);
        // console.log(res.data.data)
        this.$Message.success("正在下载");
      });
    },
    pdfsexport() {
      const data = [];
      console.log("multipleSelection", this.multipleSelection);
      if (!this.multipleSelection[0].distribution.includes(this.$route.query.caseExperimentDistribution)) {
        this.$Message.warning("未到案例结束阶段，不能下载");
        return false;
      }
      for (let e = 0; e < this.multipleSelection.length; e++) {
        // console.log(this.multipleSelection)
        data.push({
          experimentId: this.multipleSelection[e].experimentId,
          userId: this.multipleSelection[e].userCode
        });
      }
      if (data.length === 0) {
        this.$Message.warning("请选择!");
        return false;
      }
      const filter = this.multipleSelection.filter((value) => {
        return value.experimentMemberAuditStatus === "已审批";
      });
      console.log(filter);
      if (filter.length === 0) {
        this.$Message.warning("请先为报告评分!");
        return;
      }
      // console.log(data)
      this.$http.exportReportToZIp(data).then((res) => {
        if (res.data.success) {
          this.downloadFile(res.data.data);
          // console.log(res.data.data)
          this.$Message.success("正在下载");
        }
      });
    },
    deleteExperimentMeber(row) {
      // 二级页面单个删除
      console.log(row);
      const data = {
        ids: [row.id]
      };
      // console.log(data.ids)
      data.ids = JSON.stringify(data.ids);
      if (row.experimentMemberAuditStatus === "已审批") {
        this.$http.deleteExperimentMeber(data).then((res) => {
          if (res.data.success) {
            this.showExperimentMeber();
            this.$Message.success("删除成功");
          }
        });
      } else {
        this.$Message.warning("未到已审批状态，不能进行删除操作!");
      }
    },
    delete1() {
      this.isdelete = false;
    },
    delete2() {
      this.$Modal.confirm({
        title: "系统提示",
        content: "<p>你确定要删除这些数据吗?</p>",
        onOk: () => {
          this.confirmdelete();
        }
      });
    },
    confirmdelete() {
      const data = {
        ids: []
      };
      for (let e = 0; e < this.multipleSelection.length; e++) {
        data.ids.push(this.multipleSelection[e].id);
      }
      const arr = [];
      for (let i = 0; i < this.multipleSelection.length; i++) {
        arr.push(this.multipleSelection[i].experimentMemberAuditStatus);
      }
      console.log(arr);
      if (arr.indexOf("已审批") > -1) {
        this.isalldelete = true;
      }
      if (data.ids.length > 0 && this.isalldelete === true) {
        data.ids = JSON.stringify(data.ids);
        this.$http.deleteExperimentMeber(data).then((res) => {
          if (res.data.success) {
            this.$Message.success("删除成功");
            this.showExperimentMeber();
          }
        });
      } else {
        this.$Message.warning("未全到已审批状态，不能进行删除操作!");
      }
    },
    cancledelete() {
      this.isdelete = true;
    },
    report1() {
      this.isreport = false;
    },
    report() {
      // this.isreport = false
    },
    canclereport() {
      this.multipleSelection = [];
      this.isreport = true;
    },
    findsocredata() {
      // 获取智能评分数据
      const data = {
        experimentId: this.experimentId,
        experimentMemberAuditStatus: "待审批"
      };
      this.$http.showExperimentMeber(data).then((res) => {
        if (res.data.success) {
          this.scoredata = res.data.data.list;
          // console.log(this.scoredata);
        }
      });
    },
    handlesocredata() {
      // 点击弹框确定进行智能评分
      console.log(this.seconddata);
      // 没有勾选的情况
      if (this.multipleSelection.length === 0) {
        this.seconddata.forEach((item0) => {
          if (item0.experimentMemberAuditStatus === "待审批") {
            this.onOff1 = true;
          }
        });
        if (this.onOff1) {
          const data1 = {
            experimentId: this.seconddata[0].experimentId
          };
          this.$http.pushGradeToStu(data1).then((res) => {
            if (res.data.success) {
              this.$Message.success("已完成一键评分！");
              this.showExperimentMeber();
              this.scoreType = 2;
            }
          });
        } else {
          this.$Message.warning("暂无可评分报告！");
        }
      }
    },
    handlesocredata1() {
      // 点击弹框确定进行智能评分
      console.log(this.seconddata);
      // 没有勾选的情况
      if (this.multipleSelection.length === 0) {
        this.seconddata.forEach((item0) => {
          if (item0.experimentMemberAuditStatus === "待审批") {
            this.onOff1 = true;
          }
        });
        if (this.onOff1) {
          const data1 = {
            experimentId: this.seconddata[0].experimentId
          };
          this.$http.pushGradeIntellect(data1).then((res) => {
            if (res.data.success) {
              this.$Message.success("已完成智能评分！");
              this.showExperimentMeber();
              this.scoreType = 1;
            }
          });
        } else {
          this.$Message.warning("暂无可评分报告！");
        }
      }
    },

    handleCurrentChange1(x) {
      // 分页函数
      this.showExperimentMeber(x);
    },
    searchmethod() {
      // 搜索查询
      this.infoorseache = false;
      const data = {
        classId: this.form.classId,
        userName: this.form.userName,
        experimentMemberAuditStatus: this.form.experimentMemberAuditStatus,
        experimentId: this.experimentId
      };
      this.$http.showExperimentMeber(data).then((res) => {
        if (res.data.success) {
          this.pageData1 = res.data.data;
          this.seconddata = res.data.data.list;
        }
      });
    },
    // canclecheckbox() {
    //   this.showscore = false
    // },
    insertcheckbox() {
      this.findsocredata();
      if (this.multipleSelection.length === 0) {
        this.$Modal.confirm({
          title: "<div>系统提示</div>",
          content:
            "<div><p>你确定要为所有待审批学生进行一键评分吗?</p><p style='margin-top: 24px;text-align: center; color: #f89902;     margin-left: -40px;   font-size: 12px;'>认可系统评分，并将系统评分直接作为教师评分</p></div>",
          onOk: () => {
            this.handlesocredata();
          }
        });
      }
    },
    insertcheckbox_fix() {
      this.findsocredata();
      if (this.multipleSelection.length === 0) {
        this.$Modal.confirm({
          title: "<div>系统提示</div>",
          content:
            "<div><p>你确定要为所有待审批学生进行智能评分吗?</p><p style='margin-top: 24px;    color: #f89902;     margin-left: -40px;   font-size: 12px;'>系统自动配置基准分，教师评分由系统评分和基准分两部分构成</p></div>",
          onOk: () => {
            this.handlesocredata1();
          }
        });
      }
    },
    showExperimentMeber1() {
      // 搜索框查询班级名称
      const data = {
        experimentId: this.experimentId
      };
      this.$http.showExperimentMeber(data).then((res) => {
        if (res.data.success) {
          res.data.data.list.forEach((ele) => {
            // console.log(ele.className);
            this.classinfo.push({
              classname: ele.className,
              classid: ele.classId
            });
            // console.log(ele.classId)
          });
          // console.log(this.classinfo)
          this.classinfoend = this.deteleObject(this.classinfo);
        }
      });
    },
    showExperimentMeber(x) {
      // 二级页面查询数据
      const data = {
        pageNo: x,
        pageSize: 10,
        experimentId: this.experimentId
      };
      this.$http.showExperimentMeber(data).then((res) => {
        if (res.data.success) {
          console.log("642", res);
          this.pageData1 = res.data.data;
          this.seconddata = res.data.data.list;
          this.seconddata.forEach((res1) => {
            if (res1.experimentMemberAuditStatus === "未提交") {
              res1.systemScore = "待评分";
              res1.teacherScore = "待评分";
            } else if (res1.experimentMemberAuditStatus === "待审批") {
              res1.teacherScore = "待评分";
            }
          });
        }
      });
    },
    bread() {
      this.form = {
        classId: "",
        userName: "",
        experimentMemberAuditStatus: ""
      };
      this.infoorseache = true;
      this.secondshow = false;
    }
  },
  created() {
    this.showExperimentMeber();
    this.showExperimentMeber1();
    try {
      this.isTeacher = JSON.parse(sessionStorage.getItem("token")).role === "teacher";
    } catch (e) {
      console.log("token error");
    }
  }
};
</script>
<style lang="stylus">
.report-second
  text-align left
  overflow hidden
  .ivu-breadcrumb
    span
      a
        color #3A76D2
  .page
    float right
    margin-top 20px
  // table
  // width auto!important
  .ivu-table-header
    table
      width 100% !important
      tr
        th
          // text-align center
  .ivu-table-body
    table
      width 100% !important
      tr
        td
          // text-align center
          .ivu-table-cell
            span
              text-overflow ellipsis
              white-space nowrap
  .ivu-table-tip
    tr
      td
        // text-align center
        &:last-child
          border-radius 8px 8px 8px 8px !important
  .ivu-page-total
    span
      color #999999
      font-size 14px
  .ivu-page-item-active
    background #57A3F3
    a
      color #FFFFFF
  .ivu-table-wrapper
    border-color #EEF2F5
    .ivu-table:after
      background #EEF2F5
      z-index -99
    .ivu-table:before
      background-color #EEF2F5
    .ivu-table
      background #EEF2F5
      padding-bottom 2px
      font-size 14px
      thead
        tr
          th
            background #EEF2F5
            font-weight bolder
            color #000
      tbody
        tr
          td
            // text-align: center;
            // border-top 1px solid #b7b7b7
            border-collapse unset
            box-sizing border-box
            height 40px
            &:first-child
              // border-left 1px solid #b7b7b7
              border-radius 8px 0 0 8px
            &:last-child
              // border-right 1px solid #b7b7b7
              border-radius 0 8px 8px 0
          &:last-child
            td
              // border-bottom 1px solid #b7b7b7 !important
  .secondtitle
    width 100%
    height auto
    margin 30px 0 30px 0
    .secondbtn1
      display inline-block
      margin-right 16px
    .secondbtn
      display inline-block
      margin-right 16px
    .info
      width 180px
      margin-right 16px
</style>
